import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { trackPageView } from './utils/analytics';

// Track initial page view
trackPageView();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);